import React from 'react';
import { withNamespaces } from 'react-i18next';
import T from 'prop-types';
import { socialLinks } from 'constants/links';

import './styles.scss';
import getSocialData from './getSocialData';

const FooterSocial = ({ isWhite }) => (
  <ul className="footer-social">
    {getSocialData(isWhite).map((item, index) => {
      return (
        <li key={index}>
          <a
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="footer-social__link"
            href={socialLinks()[item.link]}
            title={item.label}
          >
            <i
              className={`icon ${item.icon}`}
              width={item.size.width}
              height={item.size.height}
            />
          </a>
        </li>
      );
    })}
  </ul>
);

FooterSocial.propTypes = {
  isWhite: T.bool,
};

export default withNamespaces()(FooterSocial);



// WEBPACK FOOTER //
// ../src/components/Footer/Social/index.jsx